import { Avatar, InteractiveContainer } from "@jugl-web/ui-kit";
import { cx } from "@jugl-web/utils";
import { FC, ReactNode } from "react";

export type ListItemCardProps = {
  title: string;
  subTitle?: ReactNode | string;
  avatarSrc?: string | null;
  subAvatarSrc?: string | null;
  subAvatarEl?: ReactNode;
  subAvatarTitle?: string | null;
  rightContent?: ReactNode;
  className?: string;
  onClick?: () => void;
};

export const ListItemCard: FC<ListItemCardProps> = ({
  title,
  subTitle,
  avatarSrc,
  subAvatarSrc,
  subAvatarEl,
  subAvatarTitle,
  rightContent,
  className,
  onClick,
}) => (
  <InteractiveContainer
    className={cx(
      "flex items-center gap-4 rounded-2xl bg-[#F9F9FA] px-[18px] py-3 transition-colors",
      { "hover:bg-[#F5F5F8]": !!onClick },
      className
    )}
    isDisabled={!onClick}
    onClick={onClick}
  >
    <div className="relative h-[48px] w-[48px]">
      <Avatar username={title} size="lg" imageUrl={avatarSrc} />
      {subAvatarEl && (
        <div className="absolute right-[-5px] bottom-[-8px]">{subAvatarEl}</div>
      )}
      {(subAvatarSrc || subAvatarTitle) && (
        <div className="absolute right-0 bottom-[-8px]">
          <Avatar
            username={subAvatarTitle || ""}
            size="xs"
            className="h-[20px] w-[20px] border-[2px] border-solid border-white"
            imageUrl={subAvatarSrc}
          />
        </div>
      )}
    </div>
    <div className="min-w-0 flex-1">
      <div className="truncate leading-4 font-medium">{title}</div>
      {subTitle && (
        <div
          className="truncate text-xs leading-2 text-[#707577]"
          title={typeof subTitle === "string" ? subTitle : undefined}
        >
          {subTitle}
        </div>
      )}
    </div>
    {!!rightContent && <div className="shrink-0">{rightContent}</div>}
  </InteractiveContainer>
);
